import React from 'react';
import { FormField, FormItem } from '@/components/ui/form';
import { Checkbox } from './ui/checkbox';
import { Control } from 'react-hook-form';

interface CheckboxFieldProps {
  control: Control<any>;
  name: string;
  label: string;
  description?: string;
  className?: string;
  labelClassName?: string;
  onCheckChange?: (value: boolean) => void;
  disabled?: boolean;
}

const FormFieldCheckbox: React.FC<CheckboxFieldProps> = ({
  control,
  name,
  label,
  description,
  className,
  onCheckChange,
  labelClassName,
  disabled,
}) => {
  return (
    <FormItem className="flex flex-row items-center text-sm font-[500] align-middle space-x-3 space-y-0 p-2">
      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <>
            <Checkbox
              disabled={disabled}
              checked={field.value as boolean}
              onCheckedChange={(checked) => {
                field.onChange(checked);
                if (onCheckChange) onCheckChange(checked as boolean);
              }}
              className={className ? className : 'rounded-md w-5 h-5'}
            />
            <div className="space-y-1 leading-none align-middle">
              <span className={labelClassName}>{label}</span>
              {description && <p className="text-xs text-muted-foreground font-normal">{description}</p>}
            </div>
          </>
        )}
      />
    </FormItem>
  );
};


export default FormFieldCheckbox;
